/* import Swiper core, modules, and css */
import Swiper from 'swiper';
import { Scrollbar, FreeMode } from 'swiper/modules'; // import Swiper modules (if needed). Full list available here: https://swiperjs.com/swiper-api#modules

import './index.scss'

import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

gsap.registerPlugin(ScrollTrigger)

import { storeParams, getStoredParams } from './../../js/madeForYou.js'

import { toggleSwiperLock } from './../../js/toggleSwiperLock'

/* global fetch */
class Slider {
  static listeningToAutocloseEvent = false
  
  constructor(el) {
      this.$el = el
      
      // console.log('Slider::constructor')
  }
  async init() {
    // console.log('Slider::init')
    
    this.$el.dataset.init = true
    
    if (!Slider.listening) {
      Slider.listenToAutocloseEvent()
      Slider.listeningToAutocloseEvent = true
    }
    
    if (this.$el.dataset.madeForYou) {
      this.queryCards()
    }
    this.initSwiper()
    
    // if (this.$el.classList.contains('acf-slider--pattern')) this.initPatternObserver()
    if (this.$el.classList.contains('acf-slider--pattern')) this.initPatternTween()
    
  }
  static listenToAutocloseEvent() {
    const $closeBtn = document.querySelector('.stories-modal__close-btn')
    window.document.addEventListener('storySwiper:autoclose', () => {
      $closeBtn.click()
    }, {capture: false, passive: true, once: false} || false)
  }
  buildQuery() {
    const url = new URL(`${document.location.origin}/wp-json/piper-heidsieck/v1/mfy/`)
    const mfy = getStoredParams()
    const lang = this.$el.dataset.lang
    const excludedPostIds = mfy.ids.join(',')
    const includedTagSlugs = mfy.tags.join(',')
    url.searchParams.append('lang', lang)
    url.searchParams.append('post__not_in', excludedPostIds)
    url.searchParams.append('tag_slug__in', includedTagSlugs)
    
    // console.log(url.href)
    
    return url
  }
  async queryCards() {
    const url = this.buildQuery()
    const response = await this.betterFetch(url)
    // console.log(response)
    this.$el.querySelector('.swiper-wrapper').innerHTML = response.data
    
    // activate story cards button
    const $storyModalContainer = document.getElementById('stories-modal-container')
    this.$el.querySelectorAll('.piper-card--story').forEach($button => {
      $storyModalContainer.expandable.addToggleButton($button)
      $button.addEventListener('click', storeParams($button.dataset.storyId, $button.dataset.contentType), {capture: false, passive: true, once: true} || false)
    })
    
  }
  async betterFetch(url) {
    return fetch(url)
      .then(response => {
        if (response.ok) return response.json()
        else {
          /* An error has occured */
          return response.json()
            .catch(() => {
              /* Couldn't parse the JSON */
              return response.status
            })
            .then(({message}) => {
              /* Got valid JSON with error response, use it */
              console.error(`Got valid JSON with error response "${message || response.status}". (URL: ${url})`)
              // throw new Error(message || response.status);
              return {httpCode: response.status, errorMessage: message}
            })
        }
      })
      .catch(error => error)
  }
  // static patternObserverThreshold = Array.from(Array(20).keys().map(_index => _index / 100))
  // static patternObserverOptions = {
  //   root: null,
  //   rootMargin: "1px",
  //   threshold: 0,
  // }
  // static patternObserverCallback = (entries, observer) => {
  //   entries.forEach((entry) => {
      
  //     let opacity = 0
      
  //     if (entry.isIntersecting) {
  //       opacity = 1
  //     }
  //     entry.target.querySelector('.acf-slider__fixed-pattern').style.opacity = opacity
      
      
      
  //     /*
  //     // console.log(entry.boundingClientRect, entry.intersectionRect, entry.rootBounds)
  //     // console.log(entry.intersectionRect.height, entry.rootBounds.height)
      
  //     const pattern = this.$el.querySelector('.acf-slider__fixed-pattern')
      
  //     if (!entry.isIntersecting) {
  //       // exit rAF
  //       return pattern.style.opacity = 0
  //     } else {
  //       // start rAF
  //       // window.requestAnimationFrame()
  //     }
  //     */
      
      
  //   })
  // }
  // /* global IntersectionObserver */
  // static patternObserver = new IntersectionObserver(Slider.patternObserverCallback, Slider.patterObserverOptions)
  // initPatternObserver() {
  //   console.log( this.constructor.patternObserverThreshold )
  //   this.constructor.patternObserver.observe(this.$el)
  //   console.log('added an entry to iObserver!', this.$el)
  // }
  initPatternTween() {
    const $pattern = this.$el.querySelector('.piper-pattern--fixed')
    
    gsap.fromTo($pattern, {
      opacity: 0,
    },
    { // selector text, Array, or object
      opacity: 1,
      ease: 'linear',
      scrollTrigger: {
        trigger: this.$el, // selector or element
        start: 'top 75%',  // [trigger] [scroller] positions // was 'top bottom'
        end: 'top 25%', // [trigger] [scroller] positions // was 'top top'
        scrub: true, // or time (in seconds) to catch up
        // markers: true, // only during development!
      }
    })
  }
  initSwiper() {
    this.swiper = new Swiper('.acf-slider-swiper', {
      slidesPerView: 'auto',
      modules: [Scrollbar, FreeMode],
      scrollbar: {
        draggable: false,
        hide: false,
        el: '.swiper-scrollbar'
      },
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 0.35,
      },
      
      spaceBetween: 9,
      
      breakpoints: {
        768: {
          spaceBetween: 25
        }
      },
      
      on: {
        init: function( swiper ) {
          return toggleSwiperLock(swiper)
        },
        // click: function (swiper) {
        //   swiper.slideTo(this.clickedIndex, 1000)  
        // },
        resize: function( swiper ) {
          return toggleSwiperLock(swiper)
        },
      },
      preventClicks: true,
      slideToClickedSlide: false,
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-slider') ].forEach($block => {
        $block.expandygg = new Slider($block)
    })
}, {capture: false, passive: true, once: true} || false)
